// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ntd[data-v-0f6f0de1] {\r\n    /* there is a shorthand, TODO! 🙂 */\r\n    margin: auto 0 auto auto;\n}\n.text-right1[data-v-0f6f0de1] {\r\n    text-align: right !important;\r\n    height: 30px !important;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
